import { switchToSearchPreviewWindow } from '/search/search_functions/search_switch_window.js';
import {logOut} from '/login/logout.js';
import { createElement } from "/elements_functions/new_elements.js";
import { makeNewButton } from '/buttons_functions/custom_button_functions.js';

export function createPageHeader() {
    const header = document.createElement('header');
    const logoAndSearchBar = createElement('div', 'header-logo-and-search-bar', null);
    const logoLink = createElement('a', 'header-logo-link', null);
    logoLink.href = '/feed';
    const logo = createElement('img', null, null);
    logo.src = '/images/logo/logo3_smooth.png';
    logoLink.append(logo);

    const searchBar = document.createElement('div');
    searchBar.setAttribute('id', 'header-search-bar');
    
    const searchInput = document.createElement('input');
    searchInput.setAttribute('id', 'header-search-input');
    searchInput.placeholder = 'Search...';
    searchInput.addEventListener('keydown', (e)=>{
        if(e.key==='Enter')
            switchToSearchPreviewWindow(searchInput)
        });

    const searchButton = createElement('button', 'header-search-bar-button', null);
    const searchButtonImg = document.createElement('img');
    searchButtonImg.src = '/images/icons/search.png';
    searchButton.addEventListener('click', ()=>switchToSearchPreviewWindow(searchInput));
    searchButton.append(searchButtonImg);
    
    searchBar.append(searchInput);
    searchBar.append(searchButton);

    logoAndSearchBar.append(logoLink);
    logoAndSearchBar.append(searchBar);
    
    header.append(logoAndSearchBar);
    
    document.querySelector('body').append(header);
    makeNewButton(searchButton, 'grey', 'black', null, 'darken');

    return header;
}